import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import CastForEducationIcon from '@mui/icons-material/CastForEducation';
import DownloadIcon from '@mui/icons-material/Download';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import QuizIcon from '@mui/icons-material/Quiz';
import SchoolIcon from '@mui/icons-material/School';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import { Button, Checkbox, CircularProgress, Dialog, DialogContent, Drawer, List, ListItem } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import NotifyIcon4 from '../../assets/icons/NotificationsIcons/NotifyIcon4.svg';
import axiosInstance from "../../axios";
import GetData from '../GlobalComponents/getData';
import ActiveEmail from "../pages/sidebar/sidbarOptionsContent/Settings/components/ActiveEmail";



    const courses = localStorage.getItem('coursesLength');
    const questionLists = localStorage.getItem('qestionListsLength');
    const students = localStorage.getItem('studentsLength');
    const emailActive = localStorage.getItem("emailActive");
    const LearnersList = localStorage.getItem("LearnersList");
    const SlectedTab = sessionStorage.getItem("tab");
// Extract the app link based on user OS
function getUserOS() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (/android/.test(userAgent)) {
        return "https://play.google.com/store/apps/details?id=com.Gamizign.Students";
    }
    if (/iphone|ipad|ipod/.test(userAgent)) {
        return "https://apple.co/49Pc7I6";
    }
    if (/win/.test(userAgent)) {
        return "https://play.google.com/store/apps/details?id=com.Gamizign.Students";
    }
    if (/mac/.test(userAgent)) {
        return "https://apple.co/49Pc7I6";
    }
    if (/linux/.test(userAgent)) {
        return "https://play.google.com/store/apps/details?id=com.Gamizign.Students";
    }
    return "https://play.google.com/store/apps/details?id=com.Gamizign.Students";
}
    export const toDoList =[
        {tab:SlectedTab, title:'GetStarted.CreateAccount',status:true,detail:'accound had been created',link:``,icon:<AccountCircleIcon className="text-[#4183d9]" />},
        {tab:1, title:'GetStarted.CreateFirstQuestionList',status:questionLists>0,detail:'Create a new question list.',link:`/Dashboard/adding`,icon:<QuizIcon />},
        {tab:1, title:'GetStarted.CreateFirstCourse',status:courses>0,detail:'Create a new course.',link:`/Dashboard/CreateCourse`,icon:<CastForEducationIcon />},
        {tab:6, title:'GetStarted.AddFirstStudent',status:students>0,detail:'add a new student',link:`/Dashboard/learnerList`,icon:<SchoolIcon />},
        {tab:SlectedTab, title:'GetStarted.DownloadApp',status:false,detail:'DownloadApp',link:getUserOS(),icon:<DownloadIcon />},
        {tab:3, title:'GetStarted.PlayFirstActivity',status:false,detail:'Play arcade first activity',link:`/Dashboard/Courses`,icon:<SportsEsportsIcon />},
        {tab:1, title:'GetStarted.CreateFirstAiQuestion',status:questionLists>0,detail:'Create AI question list',link:`/Dashboard/adding`,icon:<AutoFixHighIcon />},
        {tab:SlectedTab, title:'GetStarted.ActivateYourEmail',status:emailActive,detail:'Activate your email',link:`email`,icon:<MarkEmailReadIcon />},
    ];
export default function CheckList({showCheckList, setShowCheckList}){
    const {t, i18n} = useTranslation(); 
    const [checListWidth, setChecListWidth] = useState('w-[240px]');
    const [isLoading, setIsLoading] = useState(true);
    const {data} = GetData();    
    const firstCourse_id = data?.published[0]?.course_id 
    const emailRef = useRef(null);
    useEffect(()=>{
        const getCourse = async() => {
            setIsLoading(true);
            try{
              const analytics = await axiosInstance.get(`${process.env.REACT_APP_ENDPOINT}/analytics/courses/${firstCourse_id}`);
              const done = analytics.data.score>0;
              toDoList[4].status=done;
              toDoList[5].status=done;
            }catch(error){
                console.log(error);
                
            }finally{setIsLoading(false);}
        }
        if (firstCourse_id) {
             getCourse();
        };
    },[firstCourse_id]);
    const [watchDemo, setWatchDemo] = useState(false);
    const [demoIndex, setDemoIndex] = useState(0);
    const demoVideos = [
        {title:t("GetStarted.CreateQuestionsList"), link:"https://www.youtube.com/embed/-ftdANrmAF0?si=WI5R8Ln_ILXX4CVV"},
        {title:t("GetStarted.CreateSingleCourse"), link:"https://www.youtube.com/embed/72GV0s4Ypac"},
        {title:t("GetStarted.CreateJourneyCourse"), link:"https://www.youtube.com/embed/L5cngeLkgKM?si=KCwh4-jLIKVbdKkt"},
    ]
    const navigate = useNavigate();
    const handleGetStart = (status, link, tab, action) => {
        if (!status) {
            // 👉 If it's the DownloadApp action — open link directly
            if (action === "DownloadApp") {
                window.open(link, "_blank"); // behaves like <Link />
                return;
            }
            // 👉 Special case: email click
            if (link === "email") {
                emailRef.current?.click();
                return;
            }
            // 👉 Normal navigation for all other actions
            const state = { courses: "", courseType: "", course: "", questionlist: true };
            navigate(link, { state });
            setShowCheckList(false);
            sessionStorage.setItem("tab", tab);

        } else {
            // console.log("already done");
        }
    };
    return(
        LearnersList==='show'? 
            <Drawer 
                anchor={i18n.language === 'ar' ? 'left' : 'right'}
                open={showCheckList}
                onClose={() => setShowCheckList(false)}
            >
                {/*Watch demo dialog  */}
                <Dialog open={watchDemo} onClose={()=>{setWatchDemo(false);setDemoIndex(0)}}>
                    <DialogContent>
                        <div>
                            <h2>{demoVideos[demoIndex].title}</h2>
                            <div className="aspect-w-16 aspect-h-9">
                                <iframe
                                    src={demoVideos[demoIndex].link}
                                    title={demoVideos[demoIndex].title}
                                    className="w-full h-full"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    </DialogContent>
                    <div className="flex justify-center">
                        <Button disabled={demoIndex===0} onClick={()=>setDemoIndex(demoIndex-1)}>Prev</Button>
                        <Button disabled={demoIndex===2} onClick={()=>setDemoIndex(demoIndex+1)}>Next</Button>
                    </div>
                </Dialog>

                <div className={`${checListWidth} h-[100vh] overflow-y-auto transition-all duration-300 ease-in-out bg-[#DDE5F0] shadow`}>
            <div className="flex justify-end p-5 relative">
            <img onClick={() => setShowCheckList(false)} className={`m-auto cursor-pointer absolute ${i18n.language === 'ar' ? 'right' : 'left'}5 `} src={NotifyIcon4} alt="NotifyIcon4" />
          </div>
            <h1 className={`text-center ${checListWidth==='w-[240px]'&&'text-2xl'}`}>{t('GetStarted.GetStarted')}</h1>
                    <div className="flex justify-center text-xl font-bold">
                        <button onClick={() => setWatchDemo(true)}>Watch Demo</button>
                    </div>
            <List>
            {toDoList.map((list, index)=>(
                <div>
                {isLoading&&index===5?<div className="flex justify-center">
                <CircularProgress/>
            </div>:(
                            
               <ListItem className="cursor-pointer" onClick={()=>handleGetStart(list.status, list.link, list.tab, list.detail)}>
                <Checkbox checked={list.status} />
                <p className={`${list.status&&'text-[#4183d9]'}`}>
                {list.icon}
                </p>
                 <span className={`text-xl ${i18n.language==='ar'?'mr-2':'ms-2'} ${list.status&&'line-through'}`}>{t(list.title)}</span>
                 </ListItem>
            )}
                </div>
            ))}
            </List>
            
        </div><div className="hidden"><ActiveEmail emailRef={emailRef}/></div></Drawer>:<></>
    )
}